
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import get from 'lodash/get';
import { NextPage } from 'next';
import getHeadingSkin from 'helpers/getHeadingSkin';
import getHeadingTag from 'helpers/getHeadingTag';
import { Data } from 'prismic/types';
import { DomainType } from 'prismic/config';
import { PageProps, ServerSideProps } from 'types/pages';
import { fetchDocumentContent } from 'prismic/helpers/fetchContent';
import { mapNextLocaleToISOLanguageCode } from 'helpers/locale.helper';
import { getDocumentRelationsFromFile } from 'prismic/getDocumentRelations';
import PageBackground from 'components/atoms/PageBackground/PageBackground';
import ComponentsRenderer from 'components/templates/partials/ComponentsRenderer';
import TemplateWrapper from 'components/templates/partials/TemplateWrapper';
import { MuseumPlan } from 'components/organisms/MuseumPlan';
import Header from 'components/organisms/Header/Header';
import { Breadcrumb } from 'components/molecules/Breadcrumb';
import Container from 'components/layout/Grid/Container';
import { Footer } from 'components/organisms/Footer';
import Column from 'components/layout/Grid/Column';
import { Heading } from 'components/atoms/Heading';
import useTranslation from 'next-translate/useTranslation';
import { HeaderSpacer } from 'components/atoms/HeaderSpacer';

export interface MuseumPlanPageProps extends Omit<PageProps, 'data'> {
  data: Data;
}

const MuseumPlanPage: NextPage<MuseumPlanPageProps> = ({ header, data, footer }) => {
  const { alternate_languages } = data;
  const { t } = useTranslation('common');
  return (
    <TemplateWrapper pageId={data.id} data={data}>
      <PageBackground />
      <Header {...header} alternateLanguages={alternate_languages} />
      <HeaderSpacer />
      <Container>
        <Column span={12}>
          <Breadcrumb />
          <Heading skin={getHeadingSkin('heading1')} elementType={getHeadingTag('heading1')}>
            {t('museumplanHeadline')}
          </Heading>
        </Column>
      </Container>

      <MuseumPlan />

      <ComponentsRenderer slices={get(data, 'data.body', [])} />

      <Footer data={get(footer, 'data.body', [])} />
    </TemplateWrapper>
  );
};

 async function _getServerSideProps({ locale, params }: ServerSideProps) {
  const { domain } = params;

  const isoLangCode = mapNextLocaleToISOLanguageCode(locale);

  const documentRelations = await getDocumentRelationsFromFile();

  const fetchedContent = await fetchDocumentContent({
    lang: isoLangCode,
    domain: domain as DomainType,
    isValidPath: true,
    uid: 'museumsplan',
  });

  if (!fetchedContent?.data) {
    console.error(`No content found ->`, {
      lang: isoLangCode,
      domain: domain as DomainType,
      isValidPath: true,
      uid: 'museumsplan',
    });

    return {
      notFound: true,
    };
  }

  const { data, header, footer, type } = fetchedContent;

  return {
    props: {
      type,
      header,
      footer,
      data,
      documentRelations,
      sharedData: null,
      domain: domain as DomainType,
    } as MuseumPlanPageProps,
  };
}

export default MuseumPlanPage;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/[domain]/museumsplan/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  